var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.contact && _vm.contactModule)?_c('ModuleLoader',{attrs:{"other-module":_vm.contactModule,"entity":_vm.contact,"bus":_vm.bus,"parent-tab":_vm.alias}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }